<template>
  <div>
    <breadcrumb-component
      :moduleTitle="'Vlan Cloud'"
      :mainTitle="'Vlan Cloud Dashboard'"
      :subTitle="'Dashboard'"
    />
    <div class="row mb_20">
      <div class="col-md-8">
        <div class="h-100">
          <div class="card mb_20 dashboard_welcome_text">
            <div class="card-body p_0">
              <div class="dashboard_welcome_text_inner">
                <div class="shade">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="size-100"
                    version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xmlns:svgjs="http://svgjs.dev/svgjs"
                    width="1440"
                    height="560"
                    preserveAspectRatio="none"
                    viewBox="0 0 1440 560"
                  >
                    <g mask='url("#SvgjsMask1000")' fill="none">
                      <use xlink:href="#SvgjsSymbol1007" x="0" y="0"></use>
                      <use xlink:href="#SvgjsSymbol1007" x="720" y="0"></use>
                    </g>
                    <defs>
                      <mask id="SvgjsMask1000">
                        <rect width="1440" height="560" fill="#ffffff"></rect>
                      </mask>
                      <path
                        d="M-1 0 a1 1 0 1 0 2 0 a1 1 0 1 0 -2 0z"
                        id="SvgjsPath1003"
                      ></path>
                      <path
                        d="M-3 0 a3 3 0 1 0 6 0 a3 3 0 1 0 -6 0z"
                        id="SvgjsPath1004"
                      ></path>
                      <path
                        d="M-5 0 a5 5 0 1 0 10 0 a5 5 0 1 0 -10 0z"
                        id="SvgjsPath1001"
                      ></path>
                      <path d="M2 -2 L-2 2z" id="SvgjsPath1005"></path>
                      <path d="M6 -6 L-6 6z" id="SvgjsPath1002"></path>
                      <path d="M30 -30 L-30 30z" id="SvgjsPath1006"></path>
                    </defs>
                    <symbol id="SvgjsSymbol1007">
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="30"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="30"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="30"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="30"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="30"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="30"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="30"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="30"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="30"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="30"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="90"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="90"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="90"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="90"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1004"
                        x="90"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="90"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="90"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="90"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="90"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="90"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="150"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="150"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="150"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="150"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="150"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="150"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1004"
                        x="150"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="150"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="150"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="150"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="210"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="210"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="210"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="210"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="210"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="210"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="210"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="210"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="210"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="210"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="270"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="270"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="270"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="270"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="270"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="270"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="270"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="270"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="270"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="270"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="330"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="330"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="330"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="330"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="330"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="330"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="330"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="330"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="330"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="330"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1004"
                        x="390"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="390"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="390"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="390"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="390"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="390"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="390"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="390"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="390"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="390"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="450"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1004"
                        x="450"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="450"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="450"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="450"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="450"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="450"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="450"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="450"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="450"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="510"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="510"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="510"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="510"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="510"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1004"
                        x="510"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="510"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="510"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="510"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="510"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="570"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="570"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="570"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="570"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="570"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="570"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="570"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="570"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="570"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="570"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="630"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="630"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="630"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="630"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="630"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="630"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="630"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="630"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="630"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="630"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="690"
                        y="30"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="690"
                        y="90"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="690"
                        y="150"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1002"
                        x="690"
                        y="210"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1005"
                        x="690"
                        y="270"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1001"
                        x="690"
                        y="330"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="690"
                        y="390"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="690"
                        y="450"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1006"
                        x="690"
                        y="510"
                        stroke="rgba(32, 43, 61, 1)"
                        stroke-width="3"
                      ></use>
                      <use
                        xlink:href="#SvgjsPath1003"
                        x="690"
                        y="570"
                        stroke="rgba(32, 43, 61, 1)"
                      ></use>
                    </symbol>
                  </svg>
                </div>
                <div class="text">
                  <p class="username">Hello {{ customer?.name }}!</p>
                  <h2>Welcome to Vlan24 Server Solutions!</h2>
                  <p>
                    We're excited to have you onboard. From here, you can easily
                    manage your servers, monitor performance, and explore our
                    range of network solutions designed to keep your business
                    running smoothly. If you need any assistance, our support
                    team is just a click away.
                  </p>
                  <router-link :to="{ name: 'cloud_servers' }">
                    <button type="button" class="btn btn-sm btn-primary">
                      Take a Service
                    </button>
                  </router-link>
                </div>
                <div class="img">
                  <img
                    src="assets/media/images/dashboard/dashboard-element1.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="can('view_payment')">
            <template
              v-for="(monthlyCost, mIndex) in monthlyCosts"
              :key="'monthly_total_' + mIndex"
            >
              <div class="col-6">
                <div class="card dashboard_monthly_bill">
                  <div class="card-body">
                    <h5 class="card-title" v-if="mIndex == 'Full Month'">
                      Estimated Monthly Bill
                    </h5>
                    <h5 class="card-title" v-else>This Month’s Bill</h5>
                    <div class="bill_amount">
                      <div class="bill_amount_text">
                        <h2>{{ formatPrice(monthlyCost.total) }}</h2>
                        <p class="date">{{ monthlyCost.period }}</p>
                      </div>
                      <div class="icon" v-if="mIndex == 'Full Month'">
                        <svg
                          height="200px"
                          width="200px"
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 460 460"
                          xml:space="preserve"
                          fill="#000000"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <path
                                style="fill: #366796"
                                d="M230.001,0c-127.026,0-230,102.975-230,230c0,119.884,91.72,218.344,208.816,229.038 l249.996-252.554C447.034,90.505,349.086,0,230.001,0z"
                              ></path>
                              <path
                                style="fill: #121149"
                                d="M156.087,406.289l52.731,52.731c6.977,0.637,14.039,0.98,21.182,0.98c127.025,0,230-102.974,230-230 c0-7.642-0.382-15.195-1.11-22.645L304.581,53.045L156.087,406.289z"
                              ></path>
                              <path
                                style="fill: #0036b3"
                                d="M335.333,291.092v40.95c0,57.991-47.009,105-105,105l-21-145.95L335.333,291.092L335.333,291.092z"
                              ></path>
                              <path
                                style="fill: #31395e"
                                d="M230.333,291.092v145.95c-57.992,0-105-47.009-105-105v-40.95L230.333,291.092L230.333,291.092z"
                              ></path>
                              <path
                                style="fill: #c2c2c2"
                                d="M335.333,250.142v40.95c0,57.992-47.009,105-105,105l-21-145.95L335.333,250.142L335.333,250.142z"
                              ></path>
                              <path
                                style="fill: #1a53ff"
                                d="M230.333,250.142v145.95c-57.992,0-105-47.008-105-105v-40.95L230.333,250.142L230.333,250.142z"
                              ></path>
                              <path
                                style="fill: #0036b3"
                                d="M335.333,209.192v40.95c0,57.991-47.009,105-105,105l-21-145.95H335.333z"
                              ></path>
                              <path
                                style="fill: #31395e"
                                d="M230.333,209.192v145.95c-57.992,0-105-47.009-105-105v-40.95H230.333z"
                              ></path>
                              <path
                                style="fill: #c2c2c2"
                                d="M335.333,168.242v40.95c0,57.992-47.009,105-105,105l-21-145.95L335.333,168.242L335.333,168.242z"
                              ></path>
                              <path
                                style="fill: #1a53ff"
                                d="M230.333,168.242v145.95c-57.992,0-105-47.008-105-105v-40.95L230.333,168.242L230.333,168.242z"
                              ></path>
                              <path
                                style="fill: #0036b3"
                                d="M335.333,127.292v40.95c0,57.992-47.009,105-105,105l-21-145.95 C209.334,127.292,335.333,127.292,335.333,127.292z"
                              ></path>
                              <path
                                style="fill: #31395e"
                                d="M230.333,127.292v145.95c-57.992,0-105-47.009-105-105v-40.95 C125.333,127.292,230.333,127.292,230.333,127.292z"
                              ></path>
                              <path
                                style="fill: #c2c2c2"
                                d="M335.333,127.292c0,57.992-47.009,105-105,105l-73.5-105l73.5-105 C288.326,22.292,335.333,69.3,335.333,127.292z"
                              ></path>
                              <path
                                style="fill: #1a53ff"
                                d="M125.334,127.292c0,57.991,47.009,105,105,105v-210C172.342,22.292,125.334,69.3,125.334,127.292z"
                              ></path>
                              <path
                                style="fill: #31395e"
                                d="M230.333,212.292l-53.125-85l53.125-85c46.869,0,85,38.131,85,85S277.203,212.292,230.333,212.292z"
                              ></path>
                              <path
                                style="fill: #ffffff"
                                d="M145.333,127.292c0,46.869,38.131,85,85,85v-170C183.465,42.292,145.333,80.422,145.333,127.292z"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div class="icon" v-else>
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 460 460"
                          xml:space="preserve"
                          fill="#000000"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <path
                                style="fill: #3a52cb"
                                d="M230,0C102.974,0,0,102.974,0,230c0,103.909,68.906,191.725,163.517,220.245l289.267-277.629 C427.292,73.356,337.212,0,230,0z"
                              ></path>
                              <path
                                style="fill: #0061e0"
                                d="M452.783,172.616L320.333,40.167L119.146,405.854l44.376,44.375 C184.569,456.575,206.883,460,230,460c127.025,0,230-102.975,230-230C460,210.187,457.494,190.959,452.783,172.616z"
                              ></path>
                              <path
                                style="fill: #121149"
                                d="M350.333,134.667v250c0,16.5-13.5,30-30,30h-90.01l-30-280L350.333,134.667L350.333,134.667z"
                              ></path>
                              <path
                                style="fill: #273b7a"
                                d="M230.323,134.667v280h-89.99c-16.5,0-30-13.5-30-30v-250L230.323,134.667L230.323,134.667z"
                              ></path>
                              <polygon
                                style="fill: #9f8d56"
                                points="320.333,204.667 320.333,384.667 230.323,384.667 210.323,194.667 "
                              ></polygon>
                              <polygon
                                style="fill: #fee187"
                                points="230.323,194.667 230.323,384.667 140.333,384.667 140.333,204.667 "
                              ></polygon>
                              <rect
                                x="213.667"
                                y="224.667"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="213.667"
                                y="278"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="213.667"
                                y="331.333"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="267"
                                y="331.333"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="267"
                                y="278"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="267"
                                y="224.667"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="160.333"
                                y="224.667"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="160.333"
                                y="331.333"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <rect
                                x="160.333"
                                y="278"
                                style="fill: #273b7a"
                                width="33.333"
                                height="33.333"
                              ></rect>
                              <polygon
                                style="fill: #366796"
                                points="320.333,204.667 140.333,204.667 140.333,184.667 230.333,164.667 320.333,184.667 "
                              ></polygon>
                              <polygon
                                style="fill: #c2fbff"
                                points="320.333,40.167 320.333,184.667 230.323,184.667 210.323,114.667 230.323,60.737 260.323,40.167 290.333,60.737 "
                              ></polygon>
                              <polygon
                                style="fill: #ffffff"
                                points="230.323,60.737 230.323,184.667 140.333,184.667 140.333,40.167 170.333,60.737 200.333,40.167 "
                              ></polygon>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card dashboard_notice_table h-100">
          <div class="card-body">
            <h5 class="card-title mb_15">Notice</h5>
            <div class="table_responsive w-100">
              <table
                class="common_table table table_bordered table-hover w-100 mb_0"
              >
                <!-- <thead>
                              <tr>
                                  <th style="width: 70%;"></th>
                                  <th class="text-end"></th>
                              </tr>
                          </thead> -->
                <tbody>
                  <template v-if="notices && notices.length > 0"> </template>
                  <template v-else>
                    <tr>
                      <td colspan="2">No notice exists!</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb_20" v-if="proxmoxServers && proxmoxServers.length > 0">
      <div class="col-md-6">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <div class="d_flex_btwn">
              <h5 class="card-title mb_15 d_flex_start">Cpu usage</h5>
              <div class="d_flex_end">
                <div class="w-100 mr_10">
                  <select
                    v-model="proxmoxServerId"
                    @change="filterServerChartData"
                    class="form-select"
                  >
                    <option
                      v-for="(proxmoxServer, index) in proxmoxServers"
                      :key="'cpu_server_' + index"
                      :value="proxmoxServer.proxmox_vm_id"
                    >
                      {{ proxmoxServer.host_name }}
                    </option>
                  </select>
                </div>
                <div class="w-100">
                  <select
                    v-model="serverChartType"
                    @change="filterServerChartData"
                    class="form-select"
                  >
                    <option value="hour|AVERAGE">Hour - Average</option>
                    <option value="hour|MAX">Hour - Maximum</option>
                    <option value="day|AVERAGE">Day - Average</option>
                    <option value="day|MAX">Day - Maximum</option>
                    <option value="week|AVERAGE">Week - Average</option>
                    <option value="week|MAX">Week - Maximum</option>
                    <option value="month|AVERAGE">Month - Average</option>
                    <option value="month|MAX">Month - Maximum</option>
                    <option value="year|AVERAGE">Year - Average</option>
                    <option value="year|MAX">Year - Maximum</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-container">
              <div v-if="isLoadingCpu" class="chart-loader">
                <div class="spinner"></div>
              </div>
              <canvas v-show="!isLoadingCpu" id="rawCpuChart"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <div class="d_flex_btwn">
              <h5 class="card-title mb_15 d_flex_start">Memory usage</h5>
              <div class="d_flex_end">
                <div class="w-100 mr_10">
                  <select
                    v-model="proxmoxMemoryId"
                    @change="filterMemoryChartData"
                    class="form-select"
                  >
                    <option
                      v-for="(proxmoxServer, index) in proxmoxServers"
                      :key="'cpu_memory_' + index"
                      :value="proxmoxServer.proxmox_vm_id"
                    >
                      {{ proxmoxServer.host_name }}
                    </option>
                  </select>
                </div>
                <div class="w-100">
                  <select
                    v-model="memoryChartType"
                    @change="filterMemoryChartData"
                    class="form-select"
                  >
                    <option value="hour|AVERAGE">Hour - Average</option>
                    <option value="hour|MAX">Hour - Maximum</option>
                    <option value="day|AVERAGE">Day - Average</option>
                    <option value="day|MAX">Day - Maximum</option>
                    <option value="week|AVERAGE">Week - Average</option>
                    <option value="week|MAX">Week - Maximum</option>
                    <option value="month|AVERAGE">Month - Average</option>
                    <option value="month|MAX">Month - Maximum</option>
                    <option value="year|AVERAGE">Year - Average</option>
                    <option value="year|MAX">Year - Maximum</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-container">
              <div v-if="isLoadingMemory" class="chart-loader">
                <div class="spinner"></div>
              </div>
              <canvas v-show="!isLoadingMemory" id="rawMemoryChart"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <div class="d_flex_btwn">
              <h5 class="card-title mb_15 d_flex_start">Network usage</h5>
              <div class="d_flex_end">
                <div class="w-100 mr_10">
                  <select
                    v-model="proxmoxNetworkId"
                    @change="filterNetworkChartData"
                    class="form-select"
                  >
                    <option
                      v-for="(proxmoxServer, index) in proxmoxServers"
                      :key="'cpu_network_' + index"
                      :value="proxmoxServer.proxmox_vm_id"
                    >
                      {{ proxmoxServer.host_name }}
                    </option>
                  </select>
                </div>
                <div class="w-100">
                  <select
                    v-model="networkChartType"
                    @change="filterNetworkChartData"
                    class="form-select"
                  >
                    <option value="hour|AVERAGE">Hour - Average</option>
                    <option value="hour|MAX">Hour - Maximum</option>
                    <option value="day|AVERAGE">Day - Average</option>
                    <option value="day|MAX">Day - Maximum</option>
                    <option value="week|AVERAGE">Week - Average</option>
                    <option value="week|MAX">Week - Maximum</option>
                    <option value="month|AVERAGE">Month - Average</option>
                    <option value="month|MAX">Month - Maximum</option>
                    <option value="year|AVERAGE">Year - Average</option>
                    <option value="year|MAX">Year - Maximum</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-container">
              <div v-if="isLoadingNetwork" class="chart-loader">
                <div class="spinner"></div>
              </div>
              <canvas v-show="!isLoadingNetwork" id="rawNetworkChart"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <div class="d_flex_btwn">
              <h5 class="card-title mb_15 d_flex_start">Disk usage</h5>
              <div class="d_flex_end">
                <div class="w-100 mr_10">
                  <select
                    v-model="proxmoxDiskId"
                    @change="filterDiskChartData"
                    class="form-select"
                  >
                    <option
                      v-for="(proxmoxServer, index) in proxmoxServers"
                      :key="'cpu_disk_' + index"
                      :value="proxmoxServer.proxmox_vm_id"
                    >
                      {{ proxmoxServer.host_name }}
                    </option>
                  </select>
                </div>
                <div class="w-100">
                  <select
                    v-model="diskChartType"
                    @change="filterDiskChartData"
                    class="form-select"
                  >
                    <option value="hour|AVERAGE">Hour - Average</option>
                    <option value="hour|MAX">Hour - Maximum</option>
                    <option value="day|AVERAGE">Day - Average</option>
                    <option value="day|MAX">Day - Maximum</option>
                    <option value="week|AVERAGE">Week - Average</option>
                    <option value="week|MAX">Week - Maximum</option>
                    <option value="month|AVERAGE">Month - Average</option>
                    <option value="month|MAX">Month - Maximum</option>
                    <option value="year|AVERAGE">Year - Average</option>
                    <option value="year|MAX">Year - Maximum</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-container">
              <div v-if="isLoadingDisk" class="chart-loader">
                <div class="spinner"></div>
              </div>
              <canvas v-show="!isLoadingDisk" id="rawDiskChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb_20">
      <div class="col-md-6">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <h5 class="card-title mb_15">Latest Services</h5>
            <div class="table_responsive w-100">
              <table
                class="common_table table table_bordered table-hover w-100 mb_0"
              >
                <tbody>
                  <tr
                    v-for="(latestService, index) in latestServices"
                    :key="'latest_service_' + index"
                  >
                    <td>{{ index }}</td>
                    <td class="text-end">{{ latestService.name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="can('view_payment')">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <h5 class="card-title mb_15">Estimated Monthly Cost</h5>
            <div class="table_responsive w-100">
              <table
                class="common_table table table_bordered table-hover w-100 mb_0"
              >
                <tbody>
                  <template v-for="(monthlyCost, index) in monthlyCosts">
                    <template v-if="index == 'Full Month'">
                      <tr
                        v-for="(monthly, mIndex) in monthlyCost.breakdown"
                        :key="'monthly_break_' + mIndex"
                      >
                        <template v-if="mIndex != 'period'">
                          <td>{{ mIndex }}</td>
                          <td class="text-end">
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-primary mr_5"
                            >
                              {{ formatPrice(monthly) }}
                            </button>
                          </td>
                        </template>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb_20" v-if="can('my_inquiry')">
      <div class="col-md-12">
        <div class="card mb_20 dashboard_notice_table h-100">
          <div class="card-body">
            <h5 class="card-title mb_15">My Tickets</h5>
            <div class="table_responsive w-100">
              <table
                class="common_table table table_bordered table-hover w-100 mb_0"
              >
                <thead>
                  <tr>
                    <th>Ticket Number</th>
                    <th>Service Provider</th>
                    <th>Server</th>
                    <th>Title</th>
                    <th class="text-end">Submission Date</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="inquiries && inquiries.length > 0">
                    <tr
                      v-for="(inquiry, index) in inquiries"
                      :key="'inquiry_' + index"
                    >
                      <td
                        v-if="can('view_ticket')"
                        class="color_success cursor_pointer"
                        @click.prevent="openDetailsInquiry(inquiry.id)"
                      >
                        {{ inquiry.ticket_number }}
                      </td>
                      <td v-else class="color_success">
                        {{ inquiry.ticket_number }}
                      </td>
                      <td>{{ inquiry?.cloudService?.name }}</td>
                      <td>{{ inquiry?.cloudServer?.server_name }}</td>
                      <td>{{ inquiry.subject }}</td>
                      <td class="text-end">{{ inquiry.created_at }}</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="4">No ticket exists!</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BaseModal
      v-if="isShowInquiryDetailsModal"
      title="Inquiry Details"
      :closeModal="closeDetailsInquiry"
      size="modal_850p"
    >
      <InquiryDetails
        :closeModal="closeDetailsInquiry"
        :loadData="getLatestInquiries"
        :inquiryId="inquiryId"
      />
    </BaseModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import { useAbility } from '@casl/vue';
import InquiryDetails from '@/views/inquiry/InquiryDetails.vue';
import BaseModal from '@/components/BaseModal.vue';
import Chart from 'chart.js/auto';
import { nextTick } from 'vue';

export default {
  name: 'dashboard',
  components: { BreadcrumbComponent, InquiryDetails, BaseModal },
  setup() {
    const { can } = useAbility();
    return {
      can,
    };
  },
  data() {
    return {
      inquiries: [],
      notices: [],
      monthlyCosts: [],
      latestServices: [],
      proxmoxServers: [],
      isShowInquiryDetailsModal: false,
      inquiryId: null,
      queryParams: {
        page: 1,
        search: '',
        search_columns: '',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 5,
      },
      serverChartType: 'hour|AVERAGE',
      proxmoxServerId: null,
      isLoadingCpu: false,
      memoryChartType: 'hour|AVERAGE',
      proxmoxMemoryId: null,
      isLoadingMemory: false,
      networkChartType: 'hour|AVERAGE',
      proxmoxNetworkId: null,
      isLoadingNetwork: false,
      diskChartType: 'hour|AVERAGE',
      proxmoxDiskId: null,
      isLoadingDisk: false,
    };
  },
  created() {
    if (this.can('my_inquiry')) {
      this.getLatestInquiries();
    }
    if (this.can('view_payment')) {
      this.getMonthlyCosts();
    }
    this.getLatestServices();
    this.getProxmoxServers();
  },
  mounted() {
    this.chartRefreshInterval = setInterval(() => {
      this.getRawCpuChartData();
      this.getMemoryChart();
      this.getNetworkChart();
      this.getDiskChart();
    }, 2 * 60 * 1000);
  },
  beforeUnmount() {
    if (this.chartRefreshInterval) {
      clearInterval(this.chartRefreshInterval);
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
  },
  methods: {
    getLatestInquiries() {
      let params = { ...this.queryParams };
      this.axios
        .get('/my-inquiry', {
          params: params,
        })
        .then(({ data }) => {
          this.inquiries = data.data;
        });
    },
    openDetailsInquiry(inquiryId) {
      this.inquiryId = inquiryId;
      this.isShowInquiryDetailsModal = true;
    },
    closeDetailsInquiry() {
      this.inquiryId = null;
      this.isShowInquiryDetailsModal = false;
    },
    getMonthlyCosts() {
      this.axios.get('/get-monthly-costs').then((response) => {
        this.monthlyCosts = response.data;
      });
    },
    getLatestServices() {
      this.axios.get('/get-latest-services').then((response) => {
        this.latestServices = response.data;
      });
    },
    getProxmoxServers() {
      this.axios.get('/get-proxmox-servers').then((response) => {
        this.proxmoxServers = response.data.data;
        if (this.proxmoxServers.length > 0) {
          this.proxmoxServerId = this.proxmoxServers[0].proxmox_vm_id;
          this.proxmoxMemoryId = this.proxmoxServers[0].proxmox_vm_id;
          this.proxmoxNetworkId = this.proxmoxServers[0].proxmox_vm_id;
          this.proxmoxDiskId = this.proxmoxServers[0].proxmox_vm_id;
          this.getRawCpuChartData();
          this.getMemoryChart();
          this.getNetworkChart();
          this.getDiskChart();
        }
      });
    },
    filterServerChartData() {
      this.isLoadingCpu = true;
      setTimeout(() => {
        this.getRawCpuChartData();
      }, 2000);
    },

    getRawCpuChartData() {
      const [timeframe, cf] = this.serverChartType.split('|');
      this.isLoadingCpu = true;

      this.axios
        .get(`/proxmox/vm/${this.proxmoxServerId}/cpu-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const data = response.data.data;

          nextTick(() => {
            const canvas = document.getElementById('rawCpuChart');
            const ctx = canvas.getContext('2d');

            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            gradient.addColorStop(0, 'rgba(104, 119, 21, 0.7)');
            gradient.addColorStop(1, 'rgba(104, 119, 21, 0.7)');

            if (this.rawCpuChart) {
              this.rawCpuChart.destroy();
            }

            this.rawCpuChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: labels,
                datasets: [
                  {
                    label: `CPU Usage (%)`,
                    data: data,
                    borderColor: gradient,
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (context) => `${context.raw}% at ${context.label}`,
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    suggestedMax: Math.ceil(Math.max(...data) + 1),
                    ticks: {
                      callback: (val) => `${val}%`,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingCpu = false;
          });
        })
        .catch(() => {
          this.isLoadingCpu = false;
        });
    },
    filterMemoryChartData() {
      this.isLoadingMemory = true;
      setTimeout(() => {
        this.getMemoryChart();
      }, 2000);
    },
    getMemoryChart() {
      const [timeframe, cf] = this.memoryChartType.split('|');
      this.isLoadingMemory = true;
      this.axios
        .get(`/proxmox/vm/${this.proxmoxMemoryId}/memory-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const data = response.data.data;
          const total = response.data.total;
          const unit = response.data.unit; // either 'MB' or 'GB'

          nextTick(() => {
            const canvas = document.getElementById('rawMemoryChart');
            const ctx = canvas.getContext('2d');

            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            gradient.addColorStop(0, 'rgba(52, 104, 108, 0.5)');
            gradient.addColorStop(1, 'rgba(52, 104, 108, 0.5)');

            if (this.rawMemoryChart) {
              this.rawMemoryChart.destroy();
            }

            this.rawMemoryChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: labels,
                datasets: [
                  {
                    label: `Memory usage - Total`,
                    data: new Array(data.length).fill(total),
                    borderColor: 'rgba(104, 119, 21, 0.7)',
                    backgroundColor: 'rgba(104, 119, 21, 0.7)',
                    fill: true,
                    pointRadius: 0,
                    borderDash: [0, 0],
                  },
                  {
                    label: `Memory Usage - RAM Usage`,
                    data: data,
                    borderColor: gradient,
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (context) =>
                        `${context.dataset.label}: ${context.raw} ${unit}`,
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    suggestedMax: Math.ceil(Math.max(...data, total) + 1),
                    ticks: {
                      callback: (val) => `${val} ${unit}`,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingMemory = false;
          });
        })
        .catch(() => {
          this.isLoadingMemory = false;
        });
    },
    filterNetworkChartData() {
      this.isLoadingNetwork = true;
      setTimeout(() => {
        this.getNetworkChart();
      }, 2000);
    },
    getNetworkChart() {
      const [timeframe, cf] = this.networkChartType.split('|');
      const formatNumber = this.formatNumber; // 👈 Fix here
      this.isLoadingNetwork = true;
      this.axios
        .get(`/proxmox/vm/${this.proxmoxNetworkId}/network-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const netin = response.data.netin;
          const netout = response.data.netout;

          const maxValue = Math.max(...netin, ...netout);
          const paddedMax = Math.ceil(maxValue * 1.1);

          nextTick(() => {
            const canvas = document.getElementById('rawNetworkChart');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            gradient.addColorStop(0, 'rgba(52, 104, 108, 0.5)');
            gradient.addColorStop(1, 'rgba(52, 104, 108, 0.5)');

            if (this.rawNetworkChart) {
              this.rawNetworkChart.destroy();
            }

            this.rawNetworkChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels,
                datasets: [
                  {
                    label: `Network traffic - netin`,
                    data: netin,
                    borderColor: gradient,
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                  {
                    label: `Network traffic - netout`,
                    data: netout,
                    borderColor: 'rgba(104, 119, 21, 0.7)',
                    backgroundColor: 'rgba(104, 119, 21, 0.7)',
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return `${context.dataset.label}: ${formatNumber(
                          context.raw
                        )}`;
                      },
                    },
                  },
                },
                scales: {
                  y: {
                    suggestedMax: paddedMax,
                    ticks: {
                      callback: (value) => formatNumber(value),
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingNetwork = false;
          });
        })
        .catch(() => {
          this.isLoadingNetwork = false;
        });
    },
    filterDiskChartData() {
      this.isLoadingDisk = true;
      setTimeout(() => {
        this.getDiskChart();
      }, 2000);
    },
    getDiskChart() {
      const [timeframe, cf] = this.diskChartType.split('|');
      const formatNumber = this.formatNumber;
      this.isLoadingDisk = true;
      this.axios
        .get(`/proxmox/vm/${this.proxmoxDiskId}/disk-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const diskRead = response.data.diskread;
          const diskWrite = response.data.diskwrite;

          // 🔸 Add headroom above max value
          const maxValue = Math.max(...diskRead, ...diskWrite);
          const paddedMax = Math.ceil(maxValue * 1.1);

          nextTick(() => {
            const canvas = document.getElementById('rawDiskChart');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            const gradientRead = ctx.createLinearGradient(
              0,
              0,
              0,
              canvas.height
            );
            gradientRead.addColorStop(0, 'rgba(52, 104, 108, 0.5)');
            gradientRead.addColorStop(1, 'rgba(52, 104, 108, 0.5)');

            const gradientWrite = ctx.createLinearGradient(
              0,
              0,
              0,
              canvas.height
            );
            gradientWrite.addColorStop(0, 'rgba(104, 119, 21, 0.7)');
            gradientWrite.addColorStop(1, 'rgba(104, 119, 21, 0.7)');

            if (this.rawDiskChart) {
              this.rawDiskChart.destroy();
            }

            this.rawDiskChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels,
                datasets: [
                  {
                    label: `Disk IO - diskread`,
                    data: diskRead,
                    borderColor: gradientRead,
                    backgroundColor: gradientRead,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                  {
                    label: `Disk IO - diskwrite`,
                    data: diskWrite,
                    borderColor: gradientWrite,
                    backgroundColor: gradientWrite,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return `${context.dataset.label}: ${formatNumber(
                          context.raw
                        )}`;
                      },
                    },
                  },
                },
                scales: {
                  y: {
                    suggestedMax: paddedMax,
                    ticks: {
                      callback: (value) => formatNumber(value),
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingDisk = false;
          });
        })
        .catch(() => {
          this.isLoadingDisk = false;
        });
    },
    formatNumber(n) {
      if (n < 1000) return n.toString();
      const units = ['K', 'M', 'B', 'T'];
      const order = Math.floor(Math.log10(n) / 3);
      const unitname = units[order - 1];
      const num = n / Math.pow(1000, order);
      return `${num.toFixed(1)}${unitname}`;
    },
  },
};
</script>

<style scoped>
.cursor_pointer {
  cursor: pointer;
}

.chart-loader {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.chart-loader .spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #ccc;
  border-top-color: #3e8e41;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.chart-container {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.chart-container canvas {
  height: 100% !important;
  width: 100% !important;
}
</style>
